import { getIsSafari } from './get-is-safari'
import { getIsEdge } from './get-is-edge'

export function getIsFullscreen() {
  return getIsSafari() || getIsEdge()
    ? !!document.webkitFullscreenElement
    : !!document.fullscreenElement
}
